import React from 'react';
import TabsContextProvider from './TabsContextProvider';

interface IProps<T> {
  /**
   * The content of the tabs component
   */
  children: React.ReactNode,
  /**
   * Unique identifier for testing purposes
   */
  dataTest: string,
  /**
   * The default tab identifier.
   */
  defaultTab?: T,
  /**
   * Optional CSS class name for styling the tabs component
   */
  className?: string,
  /**
   * Callback function triggered when a tab is changed
   * It receives the new tab identifier as an argument
   */
  onChange?: (tabId?: T | React.SetStateAction<T>) => unknown,
}
const Tabs = <T = string | number>({ children, defaultTab, onChange, dataTest, className }: IProps<T>) => (
  <TabsContextProvider<T>
    defaultTab={ defaultTab }
    onChange={ onChange }
  >
    <div
      data-test={ dataTest }
      className={ className }
    >
      { children }
    </div>
  </TabsContextProvider>
);

export default Tabs;
